<div class="welcome-first-time">
  <p class="onboarding-welcome">
    {{ 'modals.delegatedWelcome.welcome' | translate: { name: userName } }}
  </p>

  <div class="onboarding-layout">
    <section class="text-card description-card">
      <p>{{ 'modals.delegatedWelcome.description' | translate }}</p>
    </section>

    <section class="text-card support-card">
      <p>{{ 'modals.delegatedWelcome.hint' | translate }}</p>
    </section>
  </div>
</div>
